import { functionNotImplemented } from '../helpers/functionNotImplemented';
import { HeaderStandaloneProps } from './types/headerStandalone';
import { CSSDisplay } from './RaFPromotionalBanner';
import { TrackingHelpers } from 'Components/HeaderContext';
import { IconTrayVisibility } from 'Components/IconTray';

export const placeholderProps: HeaderStandaloneProps = {
    variant: 'default', // Will be replaced in build time in `HeaderStandalone.renderer.tsx`
    t: (key: string, params: string[] = []) => {
        const placeholders = key.match(/%(d|s)/g);
        if (placeholders && params.length !== placeholders.length) {
            throw new Error(`Some or all t() params are missing for key ${key}`);
        }

        return `%i18n_${String(key)}_|_${JSON.stringify(params)}%`;
    },
    selectedNavigationItem: '%selectedNavigationItem%',
    scope: '%scope%',
    cart: {
        formattedQuantity: '%cart.formattedQuantity%',
        secondsLeft: 0,
        remindAt: 0,
        showMinicartAt: 0,
        products: [],
        totalPrice: '',
    },
    logger: console,
    title: '%title%',
    loginState: {
        isLoggedIn: false,
        isPartiallyLoggedIn: false,
    },
    linkPrefix: '%linkPrefix%',
    noOverlayForCOPNav: false,
    isOpenClubEnabled: false,
    iconTrayVisibility: '%iconTrayVisibility%' as IconTrayVisibility,
    infoBlockFreeReturnsUrl: '%infoBlockFreeReturnsUrl%',
    infoBlockDaysToReturnUrl: '%infoBlockDaysToReturnUrl%',
    promotionalBannerDisplay: '%promotionalBannerDisplay%' as CSSDisplay,
    serverSide: true,
    isOneCart: false,
    country: '%country%',
    headerIcon: '%headerIcon%',
    indexPageHref: '%indexPageHref%',
    trackingProvider: {
        ga: {
            trackNonInteractiveGenericEvent: functionNotImplemented,
            trackInteractiveGenericEvent: functionNotImplemented,
        },
        braze: {
            logCustomEvent: functionNotImplemented,
        },
        hotjar: {
            trackCustomEvent: functionNotImplemented,
        },
    } as unknown as Omit<TrackingHelpers, 'useCurrentPageType'>,
    isBurgerMenuMyWWStyleItemEnabled: false,
    voucherMenuUrl: '%voucherMenuUrl%',
    burgerMenuOnClick: functionNotImplemented,
    clubStaticHost: '',
    clubCiVersion: '%clubCiVersion%',
};
